import { Text } from '@consta/uikit/Text'
import type { ReactNode } from 'react'

export const getSimpleTooltipContent = (text: string): ReactNode & string => {
  return (
    <Text view="primary" size="xs">
      {text}
    </Text>
  ) as ReactNode & string
}
